// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HERO */

.zuppa_lms_hopg_hero_container{
display:flex;
align-items:center;
justify-content:space-between;
padding:60px 8%;
height: 90vh;
background:linear-gradient(to right,#ffb254,#e6c462);
flex-wrap:wrap;
}

.zuppa_lms_hopg_hero_text{
flex:1 1;
font-family:'Times New Roman';
}

.zuppa_lms_hopg_hero_heading{
font-size:36px;
margin:10px 0;
}

.zuppa_lms_hopg_hero_subheading{
font-size:20px;
}

.zuppa_lms_hopg_hero_button{
padding:10px 22px;
background:#020f5c;
border-radius:40px;
border:2px solid #333;
color:white;
cursor:pointer;
}

.zuppa_lms_hopg_hero_image{
flex:1 1;
max-width:500px;
width:100%;
}

/* ABOUT */

.zuppa_lms_hopg_container{
display:flex;
flex-wrap:wrap;
align-items:center;
justify-content:space-between;
padding:60px 8%;
}

.zuppa_lms_hopg_container_reverse{
display:flex;
flex-wrap:wrap;
flex-direction:row-reverse;
align-items:center;
justify-content:space-between;
padding:60px 8%;
}

.zuppa_lms_hopg_content{
flex:1 1;
max-width:600px;
font-family:'Times New Roman';
font-size:20px;
text-align:justify;
}

.zuppa_lms_hopg_image_wrapper{
flex:1 1;
text-align:center;
}

.zuppa_lms_hopg_second_image{
max-width:400px;
width:100%;
animation:rotateDrone 6s infinite linear;
}

@keyframes rotateDrone{
0%{transform:perspective(800px) rotateY(0)}
50%{transform:perspective(800px) rotateY(20deg)}
100%{transform:perspective(800px) rotateY(0)}
}

.zuppa_lms_hopg_section_heading{
font-size:32px;
font-weight:bold;
margin-bottom:20px;
}

/* FAQ */

.zuppa_lms_hopg_accordion_section{
padding:60px 8%;
display:flex;
flex-direction:column;
align-items:center;
}

.zuppa_lms_hopg_faq_heading{
font-size:30px;
margin-bottom:30px;
}

.zuppa_lms_hopg_accordion{
width:90%;
max-width:900px;
border:2px solid orange;
margin-bottom:15px;
}

.zuppa_lms_hopg_accordion_header{
width:100%;
padding:15px;
background:#f5f5f5;
font-weight:bold;
display:flex;
justify-content:space-between;
cursor:pointer;
border:none;
}

.zuppa_lms_hopg_accordion_content{
padding:15px;
background:white;
}

/* RESPONSIVE */

@media(max-width:768px){

.zuppa_lms_hopg_hero_container{
flex-direction:column;
text-align:center;
}

.zuppa_lms_hopg_container{
flex-direction:column;
}

.zuppa_lms_hopg_container_reverse{
flex-direction:column;
}

.zuppa_lms_hopg_hero_heading{
font-size:26px;
}

}

@media(max-width:480px){

.zuppa_lms_hopg_hero_heading{
font-size:22px;
}

.zuppa_lms_hopg_hero_subheading{
font-size:16px;
}

}`, "",{"version":3,"sources":["webpack://./src/Components/Home/Homepage.css"],"names":[],"mappings":"AAAA,SAAS;;AAET;AACA,YAAY;AACZ,kBAAkB;AAClB,6BAA6B;AAC7B,eAAe;AACf,YAAY;AACZ,oDAAoD;AACpD,cAAc;AACd;;AAEA;AACA,QAAM;AACN,6BAA6B;AAC7B;;AAEA;AACA,cAAc;AACd,aAAa;AACb;;AAEA;AACA,cAAc;AACd;;AAEA;AACA,iBAAiB;AACjB,kBAAkB;AAClB,kBAAkB;AAClB,qBAAqB;AACrB,WAAW;AACX,cAAc;AACd;;AAEA;AACA,QAAM;AACN,eAAe;AACf,UAAU;AACV;;AAEA,UAAU;;AAEV;AACA,YAAY;AACZ,cAAc;AACd,kBAAkB;AAClB,6BAA6B;AAC7B,eAAe;AACf;;AAEA;AACA,YAAY;AACZ,cAAc;AACd,0BAA0B;AAC1B,kBAAkB;AAClB,6BAA6B;AAC7B,eAAe;AACf;;AAEA;AACA,QAAM;AACN,eAAe;AACf,6BAA6B;AAC7B,cAAc;AACd,kBAAkB;AAClB;;AAEA;AACA,QAAM;AACN,iBAAiB;AACjB;;AAEA;AACA,eAAe;AACf,UAAU;AACV,wCAAwC;AACxC;;AAEA;AACA,GAAG,uCAAuC;AAC1C,IAAI,2CAA2C;AAC/C,KAAK,uCAAuC;AAC5C;;AAEA;AACA,cAAc;AACd,gBAAgB;AAChB,kBAAkB;AAClB;;AAEA,QAAQ;;AAER;AACA,eAAe;AACf,YAAY;AACZ,qBAAqB;AACrB,kBAAkB;AAClB;;AAEA;AACA,cAAc;AACd,kBAAkB;AAClB;;AAEA;AACA,SAAS;AACT,eAAe;AACf,uBAAuB;AACvB,kBAAkB;AAClB;;AAEA;AACA,UAAU;AACV,YAAY;AACZ,kBAAkB;AAClB,gBAAgB;AAChB,YAAY;AACZ,6BAA6B;AAC7B,cAAc;AACd,WAAW;AACX;;AAEA;AACA,YAAY;AACZ,gBAAgB;AAChB;;AAEA,eAAe;;AAEf;;AAEA;AACA,qBAAqB;AACrB,iBAAiB;AACjB;;AAEA;AACA,qBAAqB;AACrB;;AAEA;AACA,qBAAqB;AACrB;;AAEA;AACA,cAAc;AACd;;AAEA;;AAEA;;AAEA;AACA,cAAc;AACd;;AAEA;AACA,cAAc;AACd;;AAEA","sourcesContent":["/* HERO */\r\n\r\n.zuppa_lms_hopg_hero_container{\r\ndisplay:flex;\r\nalign-items:center;\r\njustify-content:space-between;\r\npadding:60px 8%;\r\nheight: 90vh;\r\nbackground:linear-gradient(to right,#ffb254,#e6c462);\r\nflex-wrap:wrap;\r\n}\r\n\r\n.zuppa_lms_hopg_hero_text{\r\nflex:1;\r\nfont-family:'Times New Roman';\r\n}\r\n\r\n.zuppa_lms_hopg_hero_heading{\r\nfont-size:36px;\r\nmargin:10px 0;\r\n}\r\n\r\n.zuppa_lms_hopg_hero_subheading{\r\nfont-size:20px;\r\n}\r\n\r\n.zuppa_lms_hopg_hero_button{\r\npadding:10px 22px;\r\nbackground:#020f5c;\r\nborder-radius:40px;\r\nborder:2px solid #333;\r\ncolor:white;\r\ncursor:pointer;\r\n}\r\n\r\n.zuppa_lms_hopg_hero_image{\r\nflex:1;\r\nmax-width:500px;\r\nwidth:100%;\r\n}\r\n\r\n/* ABOUT */\r\n\r\n.zuppa_lms_hopg_container{\r\ndisplay:flex;\r\nflex-wrap:wrap;\r\nalign-items:center;\r\njustify-content:space-between;\r\npadding:60px 8%;\r\n}\r\n\r\n.zuppa_lms_hopg_container_reverse{\r\ndisplay:flex;\r\nflex-wrap:wrap;\r\nflex-direction:row-reverse;\r\nalign-items:center;\r\njustify-content:space-between;\r\npadding:60px 8%;\r\n}\r\n\r\n.zuppa_lms_hopg_content{\r\nflex:1;\r\nmax-width:600px;\r\nfont-family:'Times New Roman';\r\nfont-size:20px;\r\ntext-align:justify;\r\n}\r\n\r\n.zuppa_lms_hopg_image_wrapper{\r\nflex:1;\r\ntext-align:center;\r\n}\r\n\r\n.zuppa_lms_hopg_second_image{\r\nmax-width:400px;\r\nwidth:100%;\r\nanimation:rotateDrone 6s infinite linear;\r\n}\r\n\r\n@keyframes rotateDrone{\r\n0%{transform:perspective(800px) rotateY(0)}\r\n50%{transform:perspective(800px) rotateY(20deg)}\r\n100%{transform:perspective(800px) rotateY(0)}\r\n}\r\n\r\n.zuppa_lms_hopg_section_heading{\r\nfont-size:32px;\r\nfont-weight:bold;\r\nmargin-bottom:20px;\r\n}\r\n\r\n/* FAQ */\r\n\r\n.zuppa_lms_hopg_accordion_section{\r\npadding:60px 8%;\r\ndisplay:flex;\r\nflex-direction:column;\r\nalign-items:center;\r\n}\r\n\r\n.zuppa_lms_hopg_faq_heading{\r\nfont-size:30px;\r\nmargin-bottom:30px;\r\n}\r\n\r\n.zuppa_lms_hopg_accordion{\r\nwidth:90%;\r\nmax-width:900px;\r\nborder:2px solid orange;\r\nmargin-bottom:15px;\r\n}\r\n\r\n.zuppa_lms_hopg_accordion_header{\r\nwidth:100%;\r\npadding:15px;\r\nbackground:#f5f5f5;\r\nfont-weight:bold;\r\ndisplay:flex;\r\njustify-content:space-between;\r\ncursor:pointer;\r\nborder:none;\r\n}\r\n\r\n.zuppa_lms_hopg_accordion_content{\r\npadding:15px;\r\nbackground:white;\r\n}\r\n\r\n/* RESPONSIVE */\r\n\r\n@media(max-width:768px){\r\n\r\n.zuppa_lms_hopg_hero_container{\r\nflex-direction:column;\r\ntext-align:center;\r\n}\r\n\r\n.zuppa_lms_hopg_container{\r\nflex-direction:column;\r\n}\r\n\r\n.zuppa_lms_hopg_container_reverse{\r\nflex-direction:column;\r\n}\r\n\r\n.zuppa_lms_hopg_hero_heading{\r\nfont-size:26px;\r\n}\r\n\r\n}\r\n\r\n@media(max-width:480px){\r\n\r\n.zuppa_lms_hopg_hero_heading{\r\nfont-size:22px;\r\n}\r\n\r\n.zuppa_lms_hopg_hero_subheading{\r\nfont-size:16px;\r\n}\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
